import { Section } from '../components/Section/Section'
import { Metric } from '../components/Metric/Metric'
import { useAnalyticsContext } from '../AnalyticsContext'

export const GrowthAndDiscovery = () => {
  const { period } = useAnalyticsContext()

  return (
    <Section title="Growth & Discovery">
      <Metric
        name="Followers"
        metricName="followers_count"
        period={period}
        tooltip="Total number of followers gained or lost over time"
        showLastSnapshotAsTotal
      />
      <Metric
        name="Impressions"
        metricName="page_impressions"
        period={period}
        tooltip="Total times all your page posts have been seen"
      />
      <Metric
        name="Engagement"
        metricName="page_engagement"
        period={period}
        tooltip="Total number of times people have engaged with your posts"
      />
      <Metric
        name="Engagement Rate"
        metricName="page_engagement_rate"
        period={period}
        tooltip="The percentage of people who saw a post and engaged with it"
      />
    </Section>
  )
}
